import type { ColorKeys, ColorSet } from './theme-and-color';

export const COLOR_KEYS: readonly ColorKeys[] = [
  'backgroundColor',
  'cardColor',
  'textFontColor',
  'headingFontColor',
  'iconColor',
  'primaryColor',
] as const;

export function areColorSetsEqual(a: ColorSet, b: ColorSet): boolean {
  return COLOR_KEYS.every((key) => a[key] === b[key]);
}
